import React from 'react';

import CustomCheckbox from './Elements/Checkbox';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import DatePicker from 'react-datepicker';
import ChonkyFileBrowser from './Chonky/ChonkyFileBrowser';

// Styles
import style from './Slideshow.module.css';
import 'react-datepicker/dist/react-datepicker.css';

import {
	vultureENV,
} from 'Vulture/ENV.js';
import { s3 } from 'S3';
import {
	downloadFile,
	safeDecode,
} from './utils/downloadFile';
import {
	buildTestData,
} from 'Vulture/TestData';
import {
	VALID_EXTENSIONS,
	validateFiles,
} from './Chonky/lib';
import Img from 'wrapper/Img';

import {
	formatTimeForPicker,
	handleStartTimeChange,
	handleEndTimeChange,
	formatDateForJSON,
	formateDateForDatePicker,
	dayMap,
	timePickerProps,
	WeekdaySelector,
	getInitialSchedulingMode,
	cleanSchedulingData,
	getSchedulingModeDisplayText,
	getSchedulingPlaceholderStyle,
	SchedulingHelperText,
} from './utils/scheduling';
import {
	releaseForceLoading,
} from './utils/forceLoading';
import { s3PublicURL } from 'Vulture/S3.js';

const basePreviewSrc = 'https://ts-pelican-resized.s3.amazonaws.com/y9DpT.jpg';
const videoPreviewSrc = 'https://ts-pelican-resized.s3.amazonaws.com/video_placeholder.jpeg';


const allowedSizes = {
	'image/*': {
		size: 10,
		unit: 'mb',
	},
	'video/*': {
		size: 400,
		unit: 'mb',
	},
};

class SlideshowModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			description:  '',
			order:        1,
			fileMetadata: {
				duration:    '15',
				description: '',
				resolution:  '',
				scheduled:   false,
				scheduling:  {
					start_date:             null,
					end_date:               null,
					days:                   [],
					recurring_start_time:   null,
					recurring_end_time:     null,
					recurring_times_by_day: {},
				},
				schedulingMode:  '',
				key:             '',
				file:            null,
				fileType:        '',
				formData:        {},
				pelicanUpdates:  {},
				previewSrc:      basePreviewSrc,
				component_uuids: [],
				order:           1,
				is_from_library: false,
			},
			file:                       null,
			modalState:                 'slide',
			originalFileMetadata:       {},
			assignContentData:          [],
			assignSearch:               '',
			durationButtonClass:        'button',
			isLibrarySelection:         false,
			confirmModal:               false,
			confirmModalContent:        '',
			replacedFile:               false,
			schedulingModeDropdownOpen: false,
		};

		this.isSaving = false;
		this.schedulingModeDropdownRef = React.createRef();
		this.schedulingSectionRef = React.createRef();
		this.timeRangesByDayRef = React.createRef();
		this.assignInlineListRef = React.createRef();
		this.assignInlinePropertyRefs = {};
		this._transitionTimer = null;
		this._forceLoadingRaised = false;
	}

	componentDidMount() {
		const {
			systemToSystemGroupObjects,
		} = this.props;

		let fileMetadata = this.state.fileMetadata;

		if (this.props.file) {
			fileMetadata = JSON.parse(JSON.stringify(this.props.file));
		}

		if (this.props.isEdit) {
			fileMetadata.previewSrc = safeDecode(this.props.file.imgURL) || this.props.file.imgURL;

			// Migrate old scheduling format to new format
			if (fileMetadata.scheduled === undefined && typeof fileMetadata.scheduling === 'boolean') {
				const oldScheduled = fileMetadata.scheduling;
				const newScheduling = {
					start_date:             null,
					end_date:               null,
					days:                   [],
					recurring_start_time:   null,
					recurring_end_time:     null,
					recurring_times_by_day: {},
				};
				let initialMode = '';

				if (fileMetadata.use_dates) {
					newScheduling.start_date = fileMetadata.start_date || null;
					newScheduling.end_date = fileMetadata.end_date || null;
				}
				if (fileMetadata.use_days && (fileMetadata.days || []).length > 0) {
					newScheduling.days = fileMetadata.days;
					initialMode = 'all-day-specific-days';
				}
				if (fileMetadata.use_times) {
					// Old times were stored as local (via getHours()), new format uses UTC (via getUTCHours())
					// Convert local HH:MM:SS to UTC HH:MM:SS during migration
					const convertLocalTimeToUTC = (localTimeStr) => {
						if (!localTimeStr) return null;
						const [ h, m, ] = localTimeStr.split(':').map(Number);
						const d = new Date();
						d.setHours(h, m, 0, 0);
						return `${d.getUTCHours().toString().padStart(2, '0')}:${d.getUTCMinutes().toString().padStart(2, '0')}:00`;
					};
					const recurringStartTime = convertLocalTimeToUTC(fileMetadata.start_time);
					const recurringEndTime = convertLocalTimeToUTC(fileMetadata.end_time);

					const hasSelectedDays = fileMetadata.use_days && (newScheduling.days || []).length > 0;
					if (hasSelectedDays) {
						initialMode = 'specific-days-with-times';
						newScheduling.recurring_times_by_day = newScheduling.days.reduce((timesByDay, day) => {
							timesByDay[day] = {
								use_recurring_times: true,
								start_time:          recurringStartTime,
								end_time:            recurringEndTime,
							};
							return timesByDay;
						}, {});
					} else {
						initialMode = 'daily-time-range';
						newScheduling.recurring_start_time = recurringStartTime;
						newScheduling.recurring_end_time = recurringEndTime;
					}
				}

				fileMetadata.scheduled = oldScheduled;
				fileMetadata.scheduling = newScheduling;
				fileMetadata.schedulingMode = initialMode;

				delete fileMetadata.use_dates;
				delete fileMetadata.use_times;
				delete fileMetadata.use_days;
				delete fileMetadata.start_date;
				delete fileMetadata.end_date;
				delete fileMetadata.start_time;
				delete fileMetadata.end_time;
				delete fileMetadata.days;
			} else if (fileMetadata.scheduled !== undefined) {
				// Already new format - ensure schedulingMode is set
				fileMetadata.schedulingMode = fileMetadata.schedulingMode ?? getInitialSchedulingMode(fileMetadata.scheduling);
			}

			this.setState({
				description:          fileMetadata.description,
				order:                fileMetadata.order,
				fileMetadata,
				originalFileMetadata: JSON.parse(JSON.stringify(fileMetadata)),
			});
		}

		document.addEventListener('mousedown', this.handleClickOutside);

		let assignContentData = [];
		let uniqueListOfDisplayNames = [];

		const bundleUUIDs = {};
		systemToSystemGroupObjects.forEach((obj) => {
			if (!obj.isBundled) return;
			if (!bundleUUIDs[obj.bundleID]) bundleUUIDs[obj.bundleID] = {};
			Object.keys(obj.componentUUIDs).forEach((u) => {
				bundleUUIDs[obj.bundleID][u] = obj.componentUUIDs[u];
			});
		});

		systemToSystemGroupObjects.forEach((systemToSystemGroupObject) => {
			let componentUUIDs = systemToSystemGroupObject.isBundled
				? bundleUUIDs[systemToSystemGroupObject.bundleID]
				: systemToSystemGroupObject.componentUUIDs;
			let checked = false;

			Object.keys(componentUUIDs).forEach((componentUUID) => {
				if (fileMetadata.component_uuids.includes(componentUUID)) {
					checked = true;
				}
			});

			let data = {
				checked,
				componentUUIDs,
				displayName: systemToSystemGroupObject.systemDisplayName,
				systemID:    systemToSystemGroupObject.systemID,
				isBundled:   systemToSystemGroupObject.isBundled,
				bundleID:    systemToSystemGroupObject.bundleID,
				systems:     systemToSystemGroupObject.systems,
			};

			if (systemToSystemGroupObject.isBundled) {
				data.displayName = systemToSystemGroupObject.bundleName;
			}

			if (!uniqueListOfDisplayNames.includes(data.displayName)) {
				uniqueListOfDisplayNames.push(data.displayName);
				assignContentData.push(data);
			}

		});

		let durationButtonClass = 'button';

		if (fileMetadata.kind && fileMetadata.kind.split('/')[0] === 'video') {
			durationButtonClass = 'button-disabled no-click';
		}

		this.nonExclusiveComponentUUIDs = systemToSystemGroupObjects
			.filter((relObj) => {
				return relObj.nonExclusive;
			})
			.reduce((accum, relObj) => {
				return [ ...accum, ...Object.keys(relObj.componentUUIDs), ];
			}, []);

		this.setState({
			assignContentData,
			durationButtonClass,
		});
	}

	openConfirmDownload = (url, fileName) => {
		this.setState({
			confirmModal: true,
			confirmModalContent: (
				<>
					<p>Would you like to download this file?</p>
					<div className="confirm-modal-buttons">
						<button className="button-outlined" onClick={async (e) => {
							e.stopPropagation();
							this.setState({
								confirmModal:     false,
								downloading:      true,
								downloadProgress: 0,
							});
							const onProgress = (p) => {
								this.setState({ downloadProgress: p });
							};

							await this.startDownloadClicked(url, fileName, onProgress);

							this.setState({
								downloading:      false,
								downloadProgress: 0,
							});
						}}>Yes</button>
						<button className="button" onClick={() => { this.setState({ confirmModal: false }); }}>No</button>
					</div>
				</>
			),
		});
	};

	async startDownloadClicked(url, fileName, onProgress = () => {}) {
		try {
			await downloadFile(url, fileName, onProgress);
			return true;
		} catch (err) {
			alert(err && (err.status === 403 || err.status === 404) ?
				'File not found. Please contact the administrator.' :
				'Download failed.');
			return false;
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
		releaseForceLoading(this._transitionTimer, this._forceLoadingRaised, this.props.app);
		this._transitionTimer = null;
		this._forceLoadingRaised = false;
	}

	handleClickOutside = (event) => {
		if (!this.state.schedulingModeDropdownOpen) {
			return;
		}
		if (this.schedulingModeDropdownRef.current && !this.schedulingModeDropdownRef.current.contains(event.target)) {
			this.setState({
				schedulingModeDropdownOpen: false,
			});
		}
	}

	toggleSchedulingModeDropdown = () => {
		this.setState((prevState) => {
			return {
				schedulingModeDropdownOpen: !prevState.schedulingModeDropdownOpen,
			};
		});
	}

	scheduleForceLoadingOff(app) {
		if (this._transitionTimer) {
			clearTimeout(this._transitionTimer);
		}
		this._transitionTimer = setTimeout(() => {
			this._transitionTimer = null;
			this._forceLoadingRaised = false;
			if (app) {
				app.setState({
					forceLoading: false,
				});
			}
		}, 300);
	}

	closeModal() {
		const {
			app,
		} = this.props;

		app.closeModal();
	}

	handleSelectImageFromLibrary(image, done = () => {}) {
		if (this.props.isEdit) {
			this.setState({
				replacedFile: true,
			});
		}
		const oldFileMetaData = this.state.fileMetadata;
		const fileMetadata = oldFileMetaData;
		fileMetadata.is_from_library = true;
		fileMetadata.previewSrc = safeDecode(image.previewURL) || image.previewURL;

		let splitName = image.name.split('.');
		let extension = splitName[splitName.length - 1];

		const videoExtensions = [ 'mp4', 'webm', ];
		const isVideo = videoExtensions.includes(extension);

		if (isVideo) {
			const imgURL = safeDecode(image.imgURL) || image.imgURL;

			const video = document.createElement('video');
			video.preload = 'metadata';
			video.crossOrigin = 'anonymous';
			video.style.display = 'none';
			document.body.appendChild(video);

			const cleanupVideo = () => {
				if (video.parentNode) video.parentNode.removeChild(video);
			};
			video.addEventListener('error', cleanupVideo, { once: true });

			if (image.imgKey && imgURL && imgURL.includes('ts-pelican')) {
				const bucketsToTry = [ 'ts-pelican', 'ts-condor-assets' ];
				const prefixes = [ 'ciprod', 'citest', 'dev', 'stage' ];
				let bareKey = safeDecode(image.imgKey) || image.imgKey;
				const maybeMatch = image.imgKey && (safeDecode(image.imgKey) || image.imgKey).match(/^(ciprod|citest|dev|stage)\/(.+)$/);
				if (maybeMatch) bareKey = maybeMatch[2];
				const candidateKeys = [ safeDecode(image.imgKey) || image.imgKey ];
				prefixes.forEach((p) => {
					const k = `${p}/${bareKey}`;
					if (!candidateKeys.includes(k)) candidateKeys.push(k);
				});
				let bi = 0, ki = 0;
				const tryNextSrc = () => {
					if (bi >= bucketsToTry.length) { video.src = imgURL; return; }
					if (ki >= candidateKeys.length) { bi += 1; ki = 0; return tryNextSrc(); }
					const params = { Bucket: bucketsToTry[bi], Key: candidateKeys[ki] };
					s3.headObject(params, (hErr, data) => {
						if (!hErr && data) {
							s3.getSignedUrl('getObject', params, (gErr, signedUrl) => {
								if (!gErr && signedUrl) {
									video.src = signedUrl;
								} else {
									video.src = imgURL;
								}
							});
						} else {
							ki += 1; tryNextSrc();
						}
					});
				};
				tryNextSrc();
			} else {
				video.src = imgURL;
			}

			video.addEventListener('loadedmetadata', () => {
				fileMetadata.duration = video.duration;
				fileMetadata.resolution = `${video.videoWidth}px x ${video.videoHeight}px`;
				fileMetadata.fileType = `video/${extension}`;
				fileMetadata.description = image.name;
				fileMetadata.file = safeDecode(image.imgKey) || image.imgKey;

				cleanupVideo();

				this.setState({
					description:         image.name,
					durationButtonClass: 'button-disabled no-click',
					isLibrarySelection:  true,
					fileMetadata,
				}, done);
			}, { once: true });
		} else {
			const imgURL = safeDecode(image.imgURL) || image.imgURL;

			const img = new Image();
			img.addEventListener('load', function () {
				fileMetadata.resolution = `${this.naturalWidth}px x ${this.naturalHeight}px`;
			});
			img.src = imgURL;

			fileMetadata.fileType = `image/${extension}`;
			fileMetadata.description = image.description;
			fileMetadata.file = safeDecode(image.imgKey) || image.imgKey;

			this.setState({
				description:        image.description,
				fileMetadata,
				isLibrarySelection: true,
			}, done);
		}
	}

	handleImageUpload(e) {
		const {
			accountUUID,
			app,
		} = this.props;

		e.preventDefault();
		if (!(e.target && e.target.files)) {
			return;
		}

		const selectedFiles = Array.from(e.target.files);
		const {
			validFiles,
			invalidFiles,
		} = validateFiles(selectedFiles);

		if (invalidFiles.length > 0) {
			const invalidNames = invalidFiles.map((file) => {
				return file.name;
			}).join(', ');
			const validExtensions = VALID_EXTENSIONS.join(', ');
			alert(`The uploaded file has an unsupported format and will be skipped: ${invalidNames}\n\nSupported formats: ${validExtensions}`);
			return;
		}

		const file = validFiles[0];
		let fileSize = file.size;
		const fileType = file.type;

		let goodSize = true;
		Object.keys(allowedSizes).forEach((key) => {
			let typeSegments = fileType.split('/');
			let sizeSegments = key.split('/');
			if (typeSegments[0] !== sizeSegments[0]) {
				return;
			}
			if (typeSegments[1] === sizeSegments[1] || sizeSegments[1] === '*') {
				let ruleUnit = allowedSizes[key].unit;
				let ruleSize = Number(allowedSizes[key].size + 1);
				if (ruleUnit === 'mb') {
					fileSize = fileSize / 1024 / 1024;
				}
				if (ruleUnit === 'kb') {
					fileSize = fileSize / 1024;
				}

				if (fileSize > ruleSize) {
					this.setState({
						confirmModal:        true,
						confirmModalContent:
						<>
							<p>{'File size: ' + Math.floor(fileSize) + '(' + ruleUnit + ') is too large for file type.'}</p>
							<div className="confirm-modal-buttons">
								<button className="button" onClick={(e) => {
									this.setState({
										confirmModal: false,
									});
								}}>Okay</button>
							</div>
						</>,
					});
					goodSize = false;
				}
			}
		});

		if (!goodSize) {
			return;
		}

		if (app) {
			this._forceLoadingRaised = true;
			app.setState({
				forceLoading: true,
			});
		}
		if (this._transitionTimer) {
			clearTimeout(this._transitionTimer);
			this._transitionTimer = null;
		}

		const clearLoading = () => {
			this._forceLoadingRaised = false;
			if (app) {
				app.setState({
					forceLoading: false,
				});
			}
		};

		let fileArray = fileType.split('/');
		let type = fileArray[0];

		let previewSrc = basePreviewSrc;
		if (type === 'image') {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onerror = clearLoading;
			reader.onabort = clearLoading;
			reader.onload = (_e) => {
				let image = new Image();
				image.onerror = clearLoading;
				image.src = reader.result;
				image.onload = () => {

					previewSrc = _e.target.result;
					const fileMetadata = this.state.fileMetadata;
					fileMetadata.is_from_library = false;
					fileMetadata.previewSrc = previewSrc;
					fileMetadata.file = `${vultureENV}/${accountUUID}/${file.name}`;
					fileMetadata.description = file.name;
					fileMetadata.fileType = fileType;
					fileMetadata.resolution = `${image.width}px x ${image.height}px`;

					if (this.props.isEdit) {
						this.setState({
							replacedFile: true,
						});
					}

					this.setState({
						description:         file.name,
						file,
						isLibrarySelection:  false,
						durationButtonClass: 'button',
						fileMetadata,
					}, () => {
						this.scheduleForceLoadingOff(app);
					});
				};
			};
			return;
		}

		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onerror = clearLoading;
		reader.onabort = clearLoading;
		reader.onload = (_e) => {
			const video = document.createElement('video');
			video.preload = 'metadata';
			video.crossOrigin = 'anonymous';
			video.style.display = 'none';
			document.body.appendChild(video);

			const videoCleanup = () => {
				if (video.parentNode) {
					video.parentNode.removeChild(video);
				}
			};

			video.addEventListener('error', () => {
				videoCleanup();
				clearLoading();
			});

			video.src = _e.target.result;

			video.addEventListener('loadedmetadata', () => {
				videoCleanup();
				previewSrc = videoPreviewSrc;
				const fileMetadata = this.state.fileMetadata;
				fileMetadata.is_from_library = false;
				fileMetadata.previewSrc = previewSrc;
				fileMetadata.file = `${app.getHashedActiveAccountName()}/${file.name}`;
				fileMetadata.description = file.name;
				fileMetadata.fileType = fileType;
				fileMetadata.duration = `${video.duration}`;

				if (this.props.isEdit) {
					this.setState({
						replacedFile: true,
					});
				}

				this.setState({
					description:         file.name,
					file,
					isLibrarySelection:  false,
					durationButtonClass: 'button-disabled no-click',
					fileMetadata,
				}, () => {
					this.scheduleForceLoadingOff(app);
				});
			});
		};
	}

	updateDays(day) {
		const {
			fileMetadata,
		} = this.state;

		const isAdding = !(fileMetadata.scheduling.days || []).includes(day);
		let days = [ ...(fileMetadata.scheduling.days || []), ];
		if (days.includes(day)) {
			days = days.filter((d) => {
				return d !== day;
			});
		} else {
			days.push(day);
		}

		days = days.sort((a, b) => {
			return a - b;
		});

		this.setState({
			fileMetadata: {
				...fileMetadata,
				scheduling: {
					...fileMetadata.scheduling,
					days,
				},
			},
		}, () => {
			if (isAdding && fileMetadata.schedulingMode === 'specific-days-with-times' && this.timeRangesByDayRef.current) {
				this.timeRangesByDayRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		});
	}


	setAssignmentCheckboxes(items, isChecked) {
		const {
			assignContentData,
			fileMetadata,
		} = this.state;

		let nonExclusiveSystemPresent = false;
		items.forEach((item) => {
			Object.keys(item.componentUUIDs).forEach((uuid) => {
				if (this.nonExclusiveComponentUUIDs.includes(uuid)) {
					nonExclusiveSystemPresent = true;
				}
			});
		});

		const cb = () => {
			const itemsSet = new Set(items);
			const updatedData = assignContentData.map((d) => {
				if (itemsSet.has(d)) {
					return { ...d, checked: isChecked };
				}
				return d;
			});

			const uuidSet = new Set(fileMetadata.component_uuids);
			
			const isBulk = items.length === assignContentData.length;

			if (isBulk) {
				uuidSet.clear();
				if (isChecked) {
					items.forEach((item) => {
						Object.keys(item.componentUUIDs).forEach((uuid) => {
							uuidSet.add(uuid);
						});
					});
				}
			} else {
				items.forEach((item) => {
					Object.keys(item.componentUUIDs).forEach((uuid) => {
						if (isChecked) {
							uuidSet.add(uuid);
						} else {
							uuidSet.delete(uuid);
						}
					});
				});
			}

			const updatedFileMetadata = {
				...fileMetadata,
				component_uuids: Array.from(uuidSet),
			};

			this.setState({
				assignContentData: updatedData,
				fileMetadata:      updatedFileMetadata,
			});
		};

		if (nonExclusiveSystemPresent) {
			this.setState({
				confirmModal:        true,
				confirmModalContent:
				<>
					<p>{`You are ${isChecked ? 'assigning this slide to' : 'unassigning this slide from'} a content group that is shared by other system groups.
					Please be aware that this action will affect other systems.`}</p>
					<div className="confirm-modal-buttons">
						<button className="button" onClick={(e) => {
							e.preventDefault();
							this.setState({
								confirmModal:        false,
								confirmModalContent: '',
							}, () => {
								cb();
							});
						}}>Yes</button>
						<button className="button" onClick={(e) => {
							this.setState({
								confirmModal: false,
							});
						}}>No</button>
					</div>
				</>,
			});
		} else {
			return cb();
		}
	}

	getMaxResolutionText(componentUUIDs) {
		for (const settings of Object.values(componentUUIDs || {})) {
			if (!settings || typeof settings !== 'object') {
				continue;
			}

			const x = settings['uploaded_img_x_resolution'];
			const y = settings['uploaded_img_y_resolution'];

			if (!x || !y) {
				continue;
			}

			return `Max: ${x}x${y}`;
		}

		return null;
	}

	getDerivedAssignData(fd, systemToSystemGroupObjects, assignContentData) {
		if (
			this._memoAssign &&
			this._memoAssign.fd === fd &&
			this._memoAssign.sysObjs === systemToSystemGroupObjects &&
			this._memoAssign.assignData === assignContentData
		) {
			return this._memoAssign.result;
		}

		const systemUUIDsMap = {};
		(systemToSystemGroupObjects || []).forEach((obj) => {
			if (!obj.isBundled) {
				systemUUIDsMap[obj.systemID] = Object.keys(obj.componentUUIDs);
			}
		});
		
		const propertyGroups = [];
		const systemGroupSystems = {};
		Object.entries(fd || {}).forEach(([ key, val, ]) => {
			if (!key.startsWith('system_group.')) return;
			const sgUUID = key.split('.')[1];
			
			if (!systemGroupSystems[sgUUID]) {
				systemGroupSystems[sgUUID] = new Set();
			}
			const sgName = (val && val.display_name) ? val.display_name : sgUUID;
			const uuidSet = new Set();
			Object.keys(val || {}).forEach((subKey) => {
				if (!subKey.startsWith('system.')) return;
				const sysUUID = subKey.split('.')[1];
				systemGroupSystems[sgUUID].add(sysUUID);
				const sysUUIDList = systemUUIDsMap[sysUUID];
				if (sysUUIDList) { sysUUIDList.forEach((u) => uuidSet.add(u)); }
			});
			const uuids = Array.from(uuidSet);
			if (systemGroupSystems[sgUUID].size > 0) propertyGroups.push({ sgUUID, sgName, uuids, });
		});
		propertyGroups.sort((a, b) => a.sgName.localeCompare(b.sgName));

		const propertyGroupItems = {};
		propertyGroups.forEach((pg) => {
			const pgSystemIDs = systemGroupSystems[pg.sgUUID] || new Set();
			propertyGroupItems[pg.sgUUID] = assignContentData.filter((d) => {
				if (d.isBundled) return (d.systems || []).some((sysKey) => pgSystemIDs.has(sysKey.split('.')[1]));
				return d.systemID && pgSystemIDs.has(d.systemID);
			});
		});

		const result = { propertyGroups, propertyGroupItems };
		this._memoAssign = { fd, sysObjs: systemToSystemGroupObjects, assignData: assignContentData, result };
		return result;
	}

	saveButton() {
		const {
			isEdit,
		} = this.props;

		const {
			isLibrarySelection,
			fileMetadata,
			originalFileMetadata,
			file,
			modalState,
		} = this.state;

		if (!isEdit) {
			if (!fileMetadata.scheduled) {
				fileMetadata.schedulingMode = '';
			}
			fileMetadata.scheduling = cleanSchedulingData(
				fileMetadata.scheduling,
				fileMetadata.scheduled,
				fileMetadata.schedulingMode
			);
			if (isLibrarySelection && fileMetadata.component_uuids.length > 0) {
				Promise.resolve(this.props.addImageReference(fileMetadata, this.closeModal.bind(this)))
					.finally(() => {
						this.isSaving = false;
					});
				return;
			}

			if (modalState === 'url') {
				if ((fileMetadata.file || '').startsWith('https://') && fileMetadata.component_uuids.length > 0) {
					Promise.resolve(this.props.addIframe(fileMetadata, this.closeModal.bind(this)))
						.finally(() => {
							this.isSaving = false;
						});
					return;
				}

				this.setState({
					confirmModal:        true,
					confirmModalContent:
					<>
						<p>{'You input a valid HTTPS URL and assign the slide to a system in order to continue saving.'}</p>
						<div className="confirm-modal-buttons">
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>Okay</button>
						</div>
					</>,
				});
				this.isSaving = false;
				return;
			}

			if (file === null || fileMetadata.component_uuids.length === 0) {
				this.setState({
					confirmModal:        true,
					confirmModalContent:
					<>
						<p>{'You must upload a file and assign it to a system in order to continue saving.'}</p>
						<div className="confirm-modal-buttons">
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>Okay</button>
						</div>
					</>,
				});
				this.isSaving = false;
				return;
			}

			Promise.resolve(this.props.addObject(file, fileMetadata, this.closeModal.bind(this)))
				.finally(() => {
					this.isSaving = false;
					this.setState({
						replacedFile: false,
					});
				});
		} else {
			if (fileMetadata.component_uuids.length === 0) {
				this.setState({
					confirmModal:        true,
					confirmModalContent:
					<>
						<p>{'You must assign the slide to a system in order to continue saving.'}</p>
						<div className="confirm-modal-buttons">
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>Okay</button>
						</div>
					</>,
				});
				this.isSaving = false;
				return;
			}
			if (!fileMetadata.scheduled) {
				fileMetadata.schedulingMode = '';
			}
			// Clean scheduling data based on mode before saving
			fileMetadata.scheduling = cleanSchedulingData(
				fileMetadata.scheduling,
				fileMetadata.scheduled,
				fileMetadata.schedulingMode
			);
			if (this.state.replacedFile) {
				fileMetadata.replacedFile = true;
			}
			Promise.resolve(this.props.editObject(fileMetadata, originalFileMetadata, this.closeModal.bind(this), this.state.file))
				.finally(() => {
					this.isSaving = false;
					this.setState({
						replacedFile: false,
					});
				});
		}
	}

	render() {
		const {
			systemGroupUUID,
			isEdit,
			allowSlideshowUrl,
		} = this.props;

		const {
			fileMetadata,
			assignContentData,
		} = this.state;


		let originalURL = '';

		if (fileMetadata?.file) {
			if (fileMetadata.is_from_library || fileMetadata.file.startsWith('uploads/')) {
				originalURL = s3PublicURL('ts-condor-assets', `${vultureENV}/ts-library/${fileMetadata.file}`);
			} else {
				originalURL = s3PublicURL('ts-pelican', `${fileMetadata.file}`);
			}
		}

		const downloadFileName = fileMetadata?.file ? fileMetadata.file.split('/').pop() : '';

		let disabledForEdit = 'button';
		// let disabledForAdd = "button";

		if (isEdit) {
			disabledForEdit = 'button button-disabled no-click button-hide';
		}

		// if (!this.props.isEdit) {
		//     disabledForAdd = "button-disabled no-click";
		// }

		let bottomButton =
		<button
			onClick={(e) => {
				this.setState({
					confirmModal:        true,
					confirmModalContent:
					<>
						<p>By cancelling you will lose your unsaved changes. Are you sure you want to continue?</p>
						<div className="confirm-modal-buttons">
							<button className="button-outlined" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
								this.closeModal();
							}}>Yes</button>
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>No</button>
						</div>
					</>,
				});
			}}
			className="button button-outlined"
		>
			Cancel
		</button>;

		if (isEdit) {
			let nonExclusiveSystemPresent = false;

			assignContentData
				.filter((contentData) => {
					return contentData.checked;
				})
				.forEach((contentData) => {
					Object.keys(contentData.componentUUIDs)
						.forEach((componentUUID) => {
							if (this.nonExclusiveComponentUUIDs.includes(componentUUID)) {
								nonExclusiveSystemPresent = true;
							}
						});
				});

			bottomButton =
				<button
					onClick={(e) => {
						if (nonExclusiveSystemPresent) {
							this.setState({
								confirmModal:        true,
								confirmModalContent:
								<>
									<p>Cannot delete slides that are assigned to systems outside this group.</p>
									<div className="confirm-modal-buttons">
										<button className="button-outlined" onClick={(e) => {
											this.setState({
												confirmModal: false,
											});
										}}>Ok</button>
									</div>
								</>,
							});
							return;
						}

						this.setState({
							confirmModal:        true,
							confirmModalContent:
							<>
								<p>Are you sure you want to delete this slide?</p>
								<div className="confirm-modal-buttons">
									<button className="button-outlined" onClick={(e) => {
										if (systemGroupUUID) {
											this.setState({
												confirmModal: false,
											});

											const updatedFileMetadata = {
												...fileMetadata,
												component_uuids: [],
											};

											this.props.editObject(updatedFileMetadata, fileMetadata, () => {
												this.props.buildPelicanData();
												this.props.app.closeModal();
											});

											return;
										}
										const uuid = fileMetadata.key;

										this.props.deleteObjects(uuid, this.closeModal.bind(this));
									}}>Yes</button>
									<button className="button" onClick={(e) => {
										this.setState({
											confirmModal: false,
										});
									}}>No</button>
								</div>
							</>,
						});
					}}
					className="button button-outlined"
				>
					<CustomIcon
						icon='trash'
					/>Delete
				</button>;
		}

		if (this.state.modalState === 'library') {
			return (
				<div className={style.slideshowModal}>
					<div className={style.libraryModalContainer}>
						<div className={style.top}>
							<div className={style.breadcrumbs}>
								<strong><span onClick={(e) => {
									this.setState({
										modalState: 'slide',
									});
								}}>Slide Details</span> {'>'} Library</strong>
							</div>
						</div>
						<LibraryModal
							accountUUID={this.props.accountUUID}
							slideshowState={this}
							handleSelectImageFromLibrary={this.handleSelectImageFromLibrary.bind(this)}
						/>
					</div>
				</div>
			);
		}

		let confirmModal = '';
		if (this.state.confirmModal === true) {
			confirmModal =
				<div className="confirm-modal-container">
					<div className="confirm-modal-content">
						{this.state.confirmModalContent}
					</div>
				</div>;
		}

		let downloadOverlay = '';
		if (this.state.downloading) {
			downloadOverlay = (
				<div className="confirm-modal-container">
					<div className="confirm-modal-content" style={{ width: '320px', textAlign: 'center' }}>
						<p>Downloading...</p>
						<div style={{ background: '#e6e6e6', borderRadius: 6, height: 12, width: '100%', overflow: 'hidden' }}>
							<div style={{ width: `${this.state.downloadProgress}%`, height: '100%', background: '#0078d4', transition: 'width 200ms ease' }} />
						</div>
						<div style={{ marginTop: 8, fontSize: 13 }}>{this.state.downloadProgress}%</div>
					</div>
				</div>
			);
		}

		return (
			<React.Fragment>
				<div className={style.slideshowModal}>
					{confirmModal}
					{downloadOverlay}
					<div className={style.slideshowModalContainer}>
						<div className={style.column1}>
							<div className={style.sectionLabel}>Details</div>
							<div className={style.uploader}>
								{(this.state.modalState === 'url' || fileMetadata.kind === 'html') ?
									<>
										{/* <div className={style.instructions}>
											<strong>URL</strong> (https required)
										</div> */}
										<div className={style.uploaderContainer}>
											<input
												value={fileMetadata.file}
												id='modalURL'
												type='text'
												style={
													{
														width:           '100%',
														height:          '100%',
														border:          'none',
														backgroundColor: 'transparent',
													}
												}
												placeholder='Insert URL here (https mandatory)'
												onChange={(e) => {
													const updatedFileMetadata = {
														...fileMetadata,
													};

													updatedFileMetadata.file = e.target.value;

													this.setState({
														fileMetadata: updatedFileMetadata,
													});
												}}
												data-testing-info={buildTestData('input--iframe-file')}
											/>
										</div>
									</> :
									<div className={style.uploaderContainer}>
										<Img
											id="modalImage"
											src={fileMetadata.previewSrc}
											alt={fileMetadata.file}
											{...(isEdit ? {
												role:        'button',
												tabIndex:    0,
												'aria-label': `Preview: ${fileMetadata.file}. Click to download`,
												style:       { cursor: 'pointer' },
												onClick: (e) => {
													e.preventDefault();
													e.stopPropagation();
													this.openConfirmDownload(originalURL, downloadFileName);
												},
												onKeyDown: (e) => {
													const key = e.key || e.keyCode;
													if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32) {
														e.preventDefault();
														e.stopPropagation();
														this.openConfirmDownload(originalURL, downloadFileName);
													}
												},
											} : {
												style: { cursor: 'default', opacity: 0.6 },
											})}
										/>
									</div>
								}
								<div className={style.uploaderFileName}>
									{fileMetadata.resolution}
								</div>
								<div className={style.uploaderButtons}>
									{!isEdit ? (
										<>
											{allowSlideshowUrl &&
												<button
													onClick={(e) => {
														const updatedFileMetadata = {
															...fileMetadata,
														};

														updatedFileMetadata.previewSrc = basePreviewSrc;
														updatedFileMetadata.fileType = 'html';

														this.setState({
															fileMetadata:       updatedFileMetadata,
															isLibrarySelection: false,
															modalState:         'url',
														});
													}}
													className={disabledForEdit}
													data-testing-info={buildTestData('button--url')}
												>
													<CustomIcon icon='globe' />URL
												</button>}
											<button
												onClick={(e) => {
													const updatedFileMetadata = {
														...fileMetadata,
													};

													updatedFileMetadata.previewSrc = basePreviewSrc;
													updatedFileMetadata.fileType = '';
													updatedFileMetadata.file = null;

													this.setState({
														fileMetadata: updatedFileMetadata,
														modalState:   'library',
													});
												}}
												className={disabledForEdit}
												data-testing-info={buildTestData('button--library')}
											>
												<CustomIcon icon='book' />Library
											</button>
											<button
												onClick={(e) => {
													const updatedFileMetadata = {
														...fileMetadata,
													};

													updatedFileMetadata.previewSrc = basePreviewSrc;
													updatedFileMetadata.fileType = '';
													updatedFileMetadata.file = null;

													this.setState({
														fileMetadata: updatedFileMetadata,
														modalState:   'slide',
													});
													document.getElementById('slideshowUploadButton').click();
												}}
												className={disabledForEdit}
												data-testing-info={buildTestData('button--uploadFile')}
											>
												<CustomIcon icon='cloud-upload-alt' />Upload File(s)
											</button>
										</>
									) : (
										<>
											<button
												onClick={(e) => {
													const updatedFileMetadata = {
														...fileMetadata,
													};
													updatedFileMetadata.previewSrc = basePreviewSrc;
													this.setState({
														fileMetadata: updatedFileMetadata,
														modalState:   'library',
													});
												}}
												className="button"
												data-testing-info={buildTestData('button--replaceLibrary')}
											>
												<CustomIcon icon='book' />Library
											</button>
											<button
												onClick={(e) => {
													document.getElementById('slideshowUploadButton').click();
												}}
												className="button"
												data-testing-info={buildTestData('button--replaceUpload')}
											>
												<CustomIcon icon='cloud-upload-alt' />Upload File(s)
											</button>
										</>
									)}
								</div>
								<input
									id="slideshowUploadButton"
									data-test-id="slideshowUploadInput"
									onChange={(e) => {
										this.handleImageUpload(e);
										e.target.value = '';
									}}
									accept={VALID_EXTENSIONS.join(',')}
									type='file'
								/>
							</div>
							 {/* File Name (non-editable) */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>File Name</label>
								</div>
								<input
									value={fileMetadata.file ? fileMetadata.file.split('/').pop() : ''}
									type='text'
									readOnly
									disabled
									style={{
										backgroundColor: '#f5f5f5',
										cursor:          'not-allowed',
									}}
									data-testing-info={buildTestData('input--filename-readonly')}
								/>
							</div>
							{/* Description */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>Description</label>
								</div>
								<textarea
									value={this.state.description}
									id='modalDescription'
									type='text'
									placeholder='Placeholder'
									onChange={(e) => {
										this.setState({
											description: e.target.value,
										});
									}}
									onBlur={(e) => {
										fileMetadata.description = e.target.value.trim();
										this.setState({
											fileMetadata,
										});
									}}
									data-testing-info={buildTestData('input--description')}
								/>
							</div>
							<div className={style.inlineFields}>
								{/* Order */}
								<div className={`text-small ${style.order}`}>
									<div className={`label ${style.label}`}>
										<label>Order</label>
									</div>
									<input
										value={this.state.order}
										id='modalOrder'
										type='number'
										placeholder='1' // TODO: max+1?
										onChange={(e) => {
											this.setState({
												order: e.target.value.trim(),
											});
										}}
										onBlur={(e) => {
											this.setState({
												fileMetadata: {
													...fileMetadata,
													order: e.target.value.trim(),
												},
											});
										}}
										data-testing-info={buildTestData('input--order')}
									/>
								</div>
								{/* Display Duration */}
								<div className={`numberPicker ${style.numberPicker}`}>
									<div className={`label ${style.label}`}>
										<label>Display Duration (seconds)</label>
									</div>
									<div className="numberPickerContainer">
										<button
											onClick={(e) => {
												e.preventDefault();
												if (fileMetadata.duration === '0') {
													return;
												}
												let duration = parseInt(fileMetadata.duration);
												fileMetadata.duration = `${duration - 1}`;
												this.setState({
													fileMetadata,
												});
											}}
											className={this.state.durationButtonClass}
										>-</button>
										<span>
											<input
												value={Math.round(fileMetadata.duration)}
												onChange={(e) => {
													if (!isNaN(Number(e.target.value))) {
														this.setState({
															fileMetadata: {
																...fileMetadata,
																duration: e.target.value,
															},
														});
													} else {
														console.warn('Invalid input', e);
													}
												}}
												data-testing-info={buildTestData('input--duration')}
											/>
										</span>
										<button
											onClick={(e) => {
												e.preventDefault();
												let duration = parseInt(fileMetadata.duration);
												fileMetadata.duration = `${duration + 1}`;
												this.setState({
													fileMetadata,
												});
											}}
											className={this.state.durationButtonClass}
										>+</button>
									</div>
								</div>
							</div>
						</div>
						<div className={style.column2}>
							<div className={style.sectionLabel}>Assign Content</div>
							{(() => {
								const {
									assignContentData,
									assignSearch,
								} = this.state;

								const fd = this.props.fd || {};
								const { propertyGroups, propertyGroupItems } = this.getDerivedAssignData(fd, this.props.systemToSystemGroupObjects, assignContentData);

								const deduped = assignContentData;

								const q = assignSearch.trim().toLowerCase();
								
								let filteredGrouped = null;
								if (q) {
									const groups = [];
									const coveredKeys = new Set();
									propertyGroups.forEach((pg) => {
										const pgItems = propertyGroupItems[pg.sgUUID] || [];
										const pgNameMatches = pg.sgName.toLowerCase().includes(q);
										const matchingItems = pgNameMatches
											? pgItems
											: pgItems.filter((d) => (d.displayName || '').toLowerCase().includes(q));
										if (matchingItems.length > 0) {
											groups.push({ pg, items: matchingItems });
											matchingItems.forEach((d) => coveredKeys.add(d.isBundled ? d.bundleID : d.systemID));
										}
									});
									const ungrouped = deduped.filter((d) => {
										const key = d.isBundled ? d.bundleID : d.systemID;
										if (coveredKeys.has(key)) return false;
										return (d.displayName || '').toLowerCase().includes(q);
									});
									filteredGrouped = { groups, ungrouped };
								}

								const isSearching = q.length > 0;
								const totalCount = deduped.length;
								const isItemChecked = (data) => data.checked;

								const selectedCount = deduped.filter(isItemChecked).length;
								const isAllAssigned = totalCount > 0 && deduped.every(isItemChecked);
								const isSomeAssigned = deduped.some(isItemChecked);

								const toggleItem = (data) => {
									this.setAssignmentCheckboxes([data], !data.checked);
								};

								const assignAll = () => {
									this.setAssignmentCheckboxes(deduped, true);
								};

								const clearAll = () => {
									this.setAssignmentCheckboxes(deduped, false);
								};

								const assignProperty = (pgUUID) => {
									const items = propertyGroupItems[pgUUID] || [];
									this.setAssignmentCheckboxes(items, true);
								};

								const clearProperty = (pgUUID) => {
									const items = propertyGroupItems[pgUUID] || [];
									this.setAssignmentCheckboxes(items, false);
								};

								const renderItem = (data, key, isIndented) => {
									const resolutionText = this.getMaxResolutionText(data.componentUUIDs);

									return (
										<label
											key={key}
											className={isIndented ? `${style.assignInlineItem} ${style.assignInlineItemIndented}` : style.assignInlineItem}
										>
											<input type="checkbox" checked={isItemChecked(data)} onChange={() => toggleItem(data)} />
											<span>{data.displayName}</span>
											{resolutionText && <span className={style.assignInlineResolution}>{resolutionText}</span>}
										</label>
									);
								};

								return (
									<div className={style.assignInlinePanel}>
										<div className={style.assignInlineSearch}>
											<div className={style.assignInlineSearchWrapper}>
												<span className={style.assignInlineSearchIcon}><CustomIcon icon="search" /></span>
												<input
													type="text"
													value={assignSearch}
													onChange={(e) => this.setState({ assignSearch: e.target.value, })}
													placeholder={`Search ${totalCount} systems...`}
												/>
												{selectedCount > 0 && (
													<span className={style.assignInlineSearchCount}>{selectedCount} selected</span>
												)}
											</div>
										</div>
										<div className={style.assignInlineActions}>
											<label className={style.assignInlineAssignAllLabel}>
												<input
													type="checkbox"
													checked={isAllAssigned}
													ref={(node) => { if (node) node.indeterminate = isSomeAssigned && !isAllAssigned; }}
													onChange={(e) => { if (e.target.checked) { assignAll(); } else { clearAll(); } }}
													onClick={(e) => e.stopPropagation()}
												/>
												<span>Assign to all {totalCount} systems</span>
											</label>
											<button type="button" className="button" onClick={clearAll}>Clear All</button>
										</div>
										{!isSearching && propertyGroups.length > 0 && (
											<div className={style.assignInlineQuickJump}>
												<span className={style.assignInlineQuickJumpLabel}>Quick:</span>
												{propertyGroups.map((pg) => (
													<button
														type="button"
														key={pg.sgUUID}
														className={style.assignInlineQuickJumpItem}
														onClick={() => {
															const listEl = this.assignInlineListRef.current;
															const el = this.assignInlinePropertyRefs[pg.sgUUID];
															if (listEl && el) {
																listEl.scrollTo({ top: el.getBoundingClientRect().top - listEl.getBoundingClientRect().top + listEl.scrollTop, behavior: 'smooth' });
															}
														}}
													>
														{pg.sgName}
													</button>
												))}
											</div>
										)}
										<div id="assign-inline-list-slideshow" ref={this.assignInlineListRef} className={style.assignInlineList}>
											{isSearching ? (
												<>
													{filteredGrouped && filteredGrouped.groups.map(({ pg, items }) => {
														const checkedCount = items.filter(isItemChecked).length;
														const isPropertyAllChecked = items.length > 0 && items.every(isItemChecked);
														const isPropertySomeChecked = items.some(isItemChecked);
														return (
															<div key={`search-pg-${pg.sgUUID}`}>
																<div className={style.assignInlinePropertyHeader}>
																	<input
																		type="checkbox"
																		checked={isPropertyAllChecked}
																		ref={(node) => { if (node) node.indeterminate = isPropertySomeChecked && !isPropertyAllChecked; }}
																		onChange={(e) => { if (e.target.checked) { this.setAssignmentCheckboxes(items, true); } else { this.setAssignmentCheckboxes(items, false); } }}
																		onClick={(e) => e.stopPropagation()}
																	/>
																	<span className={style.assignInlinePropertyName}>{pg.sgName}</span>
																	<span className={style.assignInlinePropertyCount}>{checkedCount}/{items.length}</span>
																	<button
																		type="button"
																		className={`${style.assignInlineToggleLink} ${style.assignInlinePropertyToggle}`}
																		style={{ background: 'none', border: 'none', padding: 0 }}
																		onClick={(e) => { e.preventDefault(); e.stopPropagation(); isPropertyAllChecked ? this.setAssignmentCheckboxes(items, false) : this.setAssignmentCheckboxes(items, true); }}
																	>
																		{isPropertyAllChecked ? 'Deselect all' : 'Select all'}
																	</button>
																</div>
																{items.map((data, idx) => renderItem(
																	data,
																	`assign-search-${(data.isBundled ? data.bundleID : data.systemID) || data.uuid || data.id || idx}`,
																	true
																))}
															</div>
														);
													})}
													{filteredGrouped && filteredGrouped.ungrouped.map((data, idx) => renderItem(
														data,
														`assign-search-ungrouped-${(data.isBundled ? data.bundleID : data.systemID) || data.uuid || data.id || idx}`,
														false
													))}
													{(!filteredGrouped || (filteredGrouped.groups.length === 0 && filteredGrouped.ungrouped.length === 0)) && <div className={style.assignInlineEmpty}>No systems found.</div>}
												</>
											) : propertyGroups.length > 0 ? propertyGroups.map((pg) => {
												const pgItems = propertyGroupItems[pg.sgUUID] || [];
												if (pgItems.length === 0) return null;
												const checkedCount = pgItems.filter(isItemChecked).length;
												const isPropertyAllChecked = pgItems.length > 0 && pgItems.every(isItemChecked);
												const isPropertySomeChecked = pgItems.some(isItemChecked);
												return (
													<div key={pg.sgUUID}>
														<span ref={(el) => { this.assignInlinePropertyRefs[pg.sgUUID] = el; }} style={{ display: 'block', height: 0, }} />
														<div className={style.assignInlinePropertyHeader}>
															<input
																type="checkbox"
																checked={isPropertyAllChecked}
																ref={(node) => { if (node) node.indeterminate = isPropertySomeChecked && !isPropertyAllChecked; }}
																onChange={(e) => { if (e.target.checked) { assignProperty(pg.sgUUID); } else { clearProperty(pg.sgUUID); } }}
																onClick={(e) => e.stopPropagation()}
															/>
															<span className={style.assignInlinePropertyName}>{pg.sgName}</span>
															<span className={style.assignInlinePropertyCount}>{checkedCount}/{pgItems.length}</span>
															<button
																type="button"
																className={`${style.assignInlineToggleLink} ${style.assignInlinePropertyToggle}`}
																style={{ background: 'none', border: 'none', padding: 0 }}
																onClick={(e) => { e.preventDefault(); e.stopPropagation(); isPropertyAllChecked ? clearProperty(pg.sgUUID) : assignProperty(pg.sgUUID); }}
															>
																{isPropertyAllChecked ? 'Deselect all' : 'Select all'}
															</button>
														</div>
														{pgItems.map((data, idx) => renderItem(
															data,
															`pg-${pg.sgUUID}-${(data.isBundled ? data.bundleID : data.systemID) || data.uuid || data.id || idx}`,
															true
														))}
													</div>
												);
											}) : deduped.map((data, idx) => renderItem(
												data,
												`assign-flat-${(data.isBundled ? data.bundleID : data.systemID) || data.uuid || data.id || idx}`,
												false
											))}
										</div>
									</div>
								);
							})()}
							<div className={style.sectionLabel} ref={this.schedulingSectionRef}>Scheduling</div>
							<div className={style.scheduling}>
								<div className={style.contentToggle}>
									<input
										className='on-off on-off-label'
										type='checkbox'
										checked={fileMetadata.scheduled}
										onChange={() => {
											const newScheduled = !fileMetadata.scheduled;
											this.setState({
												fileMetadata: {
													...fileMetadata,
													scheduled: newScheduled,
												},
											}, () => {
												if (newScheduled && this.schedulingSectionRef.current) {
													this.schedulingSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
												}
											});
										}}
										data-testing-info={buildTestData('input--checkbox--scheduling')}
									/> Use Scheduling
								</div>

								{fileMetadata.scheduled && (
									<>
										<div className={`text-small ${style.schedulingSection}`}>
											<div className={`label ${style.label}`}>
												<label>Active Dates</label>
											</div>
											<div className={`${style.datePicker} ${style.show}`}>
												<div className={style.startDate}>
													<DatePicker
														showIcon
														selected={formateDateForDatePicker(fileMetadata.scheduling.start_date)}
														placeholderText="Active Now"
														minDate={new Date()}
														maxDate={fileMetadata.scheduling.end_date ? Date.parse(fileMetadata.scheduling.end_date) : null}
														showTimeSelect
														timeFormat="h:mm aa"
														timeIntervals={15}
														dateFormat="MM/dd/yyyy h:mm aa"
														onChange={(e) => {
															let formattedDate = formatDateForJSON(e);
															this.setState({
																fileMetadata: {
																	...fileMetadata,
																	scheduling: {
																		...fileMetadata.scheduling,
																		start_date: formattedDate,
																	},
																},
															});
														}}
														data-testing-info={buildTestData('input--startDate')}
													/>
												</div>
												<div className={style.endDate}>
													<DatePicker
														showIcon
														selected={formateDateForDatePicker(fileMetadata.scheduling.end_date)}
														placeholderText="No Expiration"
														minDate={fileMetadata.scheduling.start_date ? Date.parse(fileMetadata.scheduling.start_date) : new Date()}
														minTime={
															fileMetadata.scheduling.start_date && fileMetadata.scheduling.end_date &&
															new Date(fileMetadata.scheduling.start_date).toDateString() === new Date(fileMetadata.scheduling.end_date).toDateString() ?
																new Date(fileMetadata.scheduling.start_date) :
																new Date().setHours(0, 0, 0, 0)
														}
														maxTime={new Date().setHours(23, 59, 59, 999)}
														showTimeSelect
														timeFormat="h:mm aa"
														timeIntervals={15}
														dateFormat="MM/dd/yyyy h:mm aa"
														onChange={(e) => {
															// Validate that end date/time is after start date/time
															let formattedDate;
															if (fileMetadata.scheduling.start_date && e <= new Date(fileMetadata.scheduling.start_date)) {
																// If end is not after start, set it to start + 15 minutes
																const newEndDate = new Date(new Date(fileMetadata.scheduling.start_date).getTime() + 15 * 60000);
																formattedDate = formatDateForJSON(newEndDate);
															} else {
																formattedDate = formatDateForJSON(e);
															}
															this.setState({
																fileMetadata: {
																	...fileMetadata,
																	scheduling: {
																		...fileMetadata.scheduling,
																		end_date: formattedDate,
																	},
																},
															});
														}}
														data-testing-info={buildTestData('input--endDate')}
													/>
												</div>
												<button className={style.clearButton}
													onClick={() => {
														this.setState({
															fileMetadata: {
																...fileMetadata,
																scheduling: {
																	...fileMetadata.scheduling,
																	start_date: null,
																	end_date:   null,
																},
															},
														});
													}}
												>Clear</button>
											</div>
											<SchedulingHelperText />
										</div>

										<div className={`text-small ${style.schedulingSection}`}>
											<div className={`label ${style.label}`}>
												<label>Display Schedule</label>
											</div>
											<div className={style.schedulingDropdownContainer} ref={this.schedulingModeDropdownRef}>
												<div
													className={style.schedulingDropdownHeader}
													onClick={this.toggleSchedulingModeDropdown}
												>
													<span className={style.schedulingDropdownHeaderText}>
														{getSchedulingModeDisplayText(fileMetadata.schedulingMode)}
													</span>
													<CustomIcon
														icon={this.state.schedulingModeDropdownOpen ? 'caret-up' : 'caret-down'}
														className={style.schedulingDropdownCaret}
													/>
												</div>

												{this.state.schedulingModeDropdownOpen && (
													<div className={style.schedulingDropdownList}>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																// Recurrence data is left untouched here so switching back
																// restores it; save-time cleaning handles the '' mode.
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		schedulingMode: '',
																	},
																	schedulingModeDropdownOpen: false,
																});
															}}
														>
															<span
																className={style.schedulingDropdownItemLabel}
																style={getSchedulingPlaceholderStyle(fileMetadata.schedulingMode)}
															>
																All Days Currently Active
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		schedulingMode: 'all-day-specific-days',
																	},
																	schedulingModeDropdownOpen: false,
																});
															}}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show all day on specific days
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		schedulingMode: 'daily-time-range',
																	},
																	schedulingModeDropdownOpen: false,
																});
															}}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show every day within specific time range
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		schedulingMode: 'specific-days-with-times',
																	},
																	schedulingModeDropdownOpen: false,
																});
															}}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show on specific days within specific time ranges per day
															</span>
														</div>
													</div>
												)}
											</div>
										</div>

										{fileMetadata.schedulingMode === 'all-day-specific-days' && (
											<div className={`text-small ${style.schedulingSection}`}>
												<div className={`label ${style.label}`}>
													<label>Recurrence: Days of Week</label>
												</div>
												<WeekdaySelector
													selectedDays={fileMetadata.scheduling.days}
													onDayToggle={(day) => {
														return this.updateDays(day);
													}}
													idSuffix="-slide"
												/>
											</div>
										)}

										{fileMetadata.schedulingMode === 'daily-time-range' && (
											<div className={`text-small ${style.schedulingSection}`}>
												<div className={`label ${style.label}`}>
													<label>Recurrence: Time Range</label>
												</div>
												<div className={`${style.timePicker} ${style.show}`}>
													<div className={style.startDate}>
														<DatePicker
															selected={formatTimeForPicker(fileMetadata.scheduling.recurring_start_time)}
															placeholderText="12:00 AM"
															{...timePickerProps}
															onChange={(e) => {
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		scheduling: {
																			...fileMetadata.scheduling,
																			recurring_start_time: handleStartTimeChange(e, fileMetadata.scheduling.recurring_end_time),
																		},
																	},
																});
															}}
														/>
													</div>
													<div className={style.endDate}>
														<DatePicker
															selected={formatTimeForPicker(fileMetadata.scheduling.recurring_end_time)}
															placeholderText="11:59 PM"
															{...timePickerProps}
															onChange={(e) => {
																this.setState({
																	fileMetadata: {
																		...fileMetadata,
																		scheduling: {
																			...fileMetadata.scheduling,
																			recurring_end_time: handleEndTimeChange(e, fileMetadata.scheduling.recurring_start_time),
																		},
																	},
																});
															}}
														/>
													</div>
													<button className={style.clearButton}
														onClick={() => {
															this.setState({
																fileMetadata: {
																	...fileMetadata,
																	scheduling: {
																		...fileMetadata.scheduling,
																		recurring_start_time: null,
																		recurring_end_time:   null,
																	},
																},
															});
														}}
													>Clear</button>
												</div>
											</div>
										)}

										{fileMetadata.schedulingMode === 'specific-days-with-times' && (
											<>
												<div className={`text-small ${style.schedulingSection}`}>
													<div className={`label ${style.label}`}>
														<label>Recurrence: Days of Week</label>
													</div>
													<WeekdaySelector
														selectedDays={fileMetadata.scheduling.days}
														onDayToggle={(day) => {
															return this.updateDays(day);
														}}
														idSuffix="-slide-times"
													/>
												</div>

												{(fileMetadata.scheduling.days || []).length > 0 && (
													<div className={`text-small ${style.schedulingSection}`} ref={this.timeRangesByDayRef}>
														<div className={`label ${style.label}`}>
															<label>Time Ranges by Day</label>
														</div>
														{(fileMetadata.scheduling.days || []).sort((a, b) => {
															return a - b;
														}).map((dayIndex) => {
															const dayName = dayMap[dayIndex];
															const dayScheduling = fileMetadata.scheduling.recurring_times_by_day?.[dayIndex] || {
																use_recurring_times: true,
																start_time:          null,
																end_time:            null,
															};

															return (
																<div key={dayIndex} className={`${style.timePicker} ${style.show}`}>
																	<span style={{
																		minWidth:   '45px',
																		fontWeight: '600',
																	}}>{dayName}:</span>
																	<div className={style.startDate}>
																		<DatePicker
																			selected={formatTimeForPicker(dayScheduling.start_time)}
																			placeholderText="12:00 AM"
																			{...timePickerProps}
																			onChange={(e) => {
																				const newFileMetadata = {
																					...fileMetadata,
																					scheduling: {
																						...fileMetadata.scheduling,
																					},
																				};
																				if (!newFileMetadata.scheduling.recurring_times_by_day) newFileMetadata.scheduling.recurring_times_by_day = {};
																				if (!newFileMetadata.scheduling.recurring_times_by_day[dayIndex]) newFileMetadata.scheduling.recurring_times_by_day[dayIndex] = {
																					use_recurring_times: true,
																				};
																				const dayEnd = newFileMetadata.scheduling.recurring_times_by_day[dayIndex]?.end_time;
																				newFileMetadata.scheduling.recurring_times_by_day[dayIndex].start_time = handleStartTimeChange(e, dayEnd);
																				this.setState({
																					fileMetadata: newFileMetadata,
																				});
																			}}
																		/>
																	</div>
																	<div className={style.endDate}>
																		<DatePicker
																			selected={formatTimeForPicker(dayScheduling.end_time)}
																			placeholderText="11:59 PM"
																			{...timePickerProps}
																			onChange={(e) => {
																				const newFileMetadata = {
																					...fileMetadata,
																					scheduling: {
																						...fileMetadata.scheduling,
																					},
																				};
																				if (!newFileMetadata.scheduling.recurring_times_by_day) newFileMetadata.scheduling.recurring_times_by_day = {};
																				if (!newFileMetadata.scheduling.recurring_times_by_day[dayIndex]) newFileMetadata.scheduling.recurring_times_by_day[dayIndex] = {
																					use_recurring_times: true,
																				};
																				const dayStart = newFileMetadata.scheduling.recurring_times_by_day[dayIndex]?.start_time;
																				newFileMetadata.scheduling.recurring_times_by_day[dayIndex].end_time = handleEndTimeChange(e, dayStart);
																				this.setState({
																					fileMetadata: newFileMetadata,
																				});
																			}}
																		/>
																	</div>
																	<button className={style.clearButton}
																		onClick={() => {
																			const newFileMetadata = {
																				...fileMetadata,
																				scheduling: {
																					...fileMetadata.scheduling,
																				},
																			};
																			if (!newFileMetadata.scheduling.recurring_times_by_day) newFileMetadata.scheduling.recurring_times_by_day = {};
																			if (!newFileMetadata.scheduling.recurring_times_by_day[dayIndex]) newFileMetadata.scheduling.recurring_times_by_day[dayIndex] = {
																				use_recurring_times: true,
																				start_time:          null,
																				end_time:            null,
																			};
																			newFileMetadata.scheduling.recurring_times_by_day[dayIndex].start_time = null;
																			newFileMetadata.scheduling.recurring_times_by_day[dayIndex].end_time = null;
																			this.setState({
																				fileMetadata: newFileMetadata,
																			});
																		}}
																	>Clear</button>
																</div>
															);
														})}
													</div>
												)}
											</>
										)}
									</>
								)}
							</div>
						</div>
					</div>

					<div className={style.library}>

					</div>

					<div className={style.bottom}>
						<div className={style.bottomInstructions}><strong>Image Format:</strong> .JPEG, .JPG and .PNG (Max: 10mb) <strong>  Movie Format:</strong>  .MP4 as H.264, WebM. (Max file size: 400 MB file size, Max Resolution: HD, and Max Framerate: 30fps)</div>
						<div className={style.bottomButtons}>
							{bottomButton}
							<button
								onClick={(e) => {
									e.preventDefault();
									if (!this.isSaving) {
										this.isSaving = true;
										this.saveButton();
									}
								}}
								className="button"
							>
								<CustomIcon icon='save' /><div>Save</div>
							</button>
						</div>
					</div>
				</div>

			</React.Fragment>
		);
	}
}

class LibraryModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			photos:      [],
			stockPhotos: [],
			activeTab:   'My Images',
		};

		this._transitionTimer = null;
		this._forceLoadingRaised = false;
	}

	componentWillUnmount() {
		releaseForceLoading(
			this._transitionTimer,
			this._forceLoadingRaised,
			this.props.slideshowState?.props?.app
		);
		this._transitionTimer = null;
		this._forceLoadingRaised = false;
	}

	render() {
		return (
			<div className={style.chonkyWrapper}>
				<ChonkyFileBrowser
					app={this.props.slideshowState.props.app}
					mode="select-image"
					readOnly={true}
					onSelectImage={(image) => {
						const app = this.props.slideshowState.props.app;
						this._forceLoadingRaised = true;
						app.setState({
							forceLoading: true,
						});
						if (this._transitionTimer) {
							clearTimeout(this._transitionTimer);
							this._transitionTimer = null;
						}

						this.props.handleSelectImageFromLibrary(image, () => {
							this._transitionTimer = setTimeout(() => {
								this._transitionTimer = null;
								this._forceLoadingRaised = false;
								app.setState({
									forceLoading: false,
								});
								this.props.slideshowState.setState({
									modalState: 'slide',
								});
							}, 300);
						});
					}}
					accountUUID={this.props.accountUUID}
					permissions={this.props.permissions}
				/>
			</div>
		);
	}
}

export default SlideshowModal;
